<span class="md-inputfield">
  <p-calendar
    #calendar
    name="calendar"
    id="calendar"
    [(ngModel)]="dataSelecionada"
    dateFormat="dd/mm/yy"
    [disabled]="bloqueado"
    [showIcon]="true"
    (onSelect)="selecionarData($event)"
    (onInput)="onInput($event)"
    (keyup.enter)="onEnter($event)"
    [minDate]="minDate"
    [panelStyleClass]="'my-datepicker-container'"
    [required]="obrigatorio"
    [yearNavigator]="yearNavigator"
    yearRange="{{yearRange}}"
    (ngModelChange)="ngModelChange && ngModelChange($event)">
  </p-calendar>
  <label>{{ placeholder }}</label>
</span>

